// 修改选中患者列表
export const SET_SELECT_LIST = 'SET_SELECT_LIST';
// 设置选中患者id
export const SET_SELECT_PATIENT_ID = 'SET_SELECT_PATIENT_ID';
// 删除选中患者列表
export const DEL_SELECT_LIST = 'DEL_SELECT_LIST';
// 修改患者列表
export const SET_PATIENT_LIST = 'SET_PATIENT_LIST';
// 删除患者列表
export const DEL_PATIENT_LIST = 'DEL_PATIENT_LIST';
export const SET_PATIENT_COUNT = 'SET_PATIENT_COUNT';
// 设置pageSize
export const SET_PAGE_SIZE = 'SET_PAGE_SIZE';
// 设置currentPage
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';
// 设置列表loading状态
export const SET_LOADING = 'SET_LOADING';
// 设置header患者姓名搜索框值
export const SET_PATIENT_NAME = 'SET_PATIENT_NAME';
// 设置是否打开关注患者列表状态
export const SET_FAVOURITE = 'SET_FAVOURITE';
// 设置患者列表查询信息
export const SET_QUERY = 'SET_QUERY';
// 设置是否显示头部
export const SET_SHOW_HEADER = 'SET_SHOW_HEADER';
// 重置搜索条件
export const SET_SEARCH_CONDITION = 'SET_SEARCH_CONDITION';

// 切换tab
export const SWITCH_TAB_INDEX = 'SWITCH_TAB_INDEX';
export const SET_CURRENT_ROUTER = 'SET_CURRENT_ROUTER';

export const SET_VISIT_PATIENT_LIST = 'SET_VISIT_PATIENT_LIST';
export const SET_VISIT_PATIENT_COUNT = 'SET_VISIT_PATIENT_COUNT';

export const SET_PREINQUIRY_PATIENT_LIST = 'SET_PREINQUIRY_PATIENT_LIST';
export const SET_PREINQUIRY_PATIENT_COUNT = 'SET_PREINQUIRY_PATIENT_COUNT';

export const SET_IMPORT_SELECT_LIST = 'SET_IMPORT_SELECT_LIST';
export const SET_VISIT_SELECT_LIST = 'SET_VISIT_SELECT_LIST';
// 检验检查报告
export const SET_REPORT_LOADING = 'SET_REPORT_LOADING';
export const SET_CHECK_REPORT_RIGHT_LOADING = 'SET_CHECK_REPORT_RIGHT_LOADING';
// 肿瘤早筛
export const SET_LOCATION_INFO = 'SET_LOCATION_INFO';
// 表单下发
export const SET_ISSUE_FORM_PATIENT_LIST = 'SET_ISSUE_FORM_PATIENT_LIST';
export const SET_ISSUE_FORM_PATIENT_COUNT = 'SET_ISSUE_FORM_PATIENT_COUNT';
// 智能外呼患者数据
export const SET_CURRENT_OUT_CALL_PATIENT = 'SET_CURRENT_OUT_CALL_PATIENT';
export const SET_OUT_CALL_COMPONENT_SHOW = 'SET_OUT_CALL_COMPONENT_SHOW';
export const SET_OUT_CALLING = 'SET_OUT_CALLING';
export const SET_OUT_CALL_ROUTER = 'SET_OUT_CALL_ROUTER';
// 院内数据模块的选中患者
export const SET_IN_HOSPITAL_SELECT_LIST = 'SET_IN_HOSPITAL_SELECT_LIST';
export const DEL_IN_HOSPITAL_SELECT_LIST = 'DEL_IN_HOSPITAL_SELECT_LIST';
export const SET_IN_HOSPITAL_FOCUS_SELECT_LIST = 'SET_IN_HOSPITAL_FOCUS_SELECT_LIST';
export const DEL_IN_HOSPITAL_FOCUS_SELECT_LIST = 'DEL_IN_HOSPITAL_FOCUS_SELECT_LIST';
// 预问诊
export const SET_PREINQUIRY_VISITID = 'SET_PREINQUIRY_VISITID';
export const SET_REMINDSUM = 'SET_REMINDSUM';
export const SET_ORGANTYPE = 'SET_ORGANTYPE';
export const SET_TAGFILTERSELECTEDLIST = 'SET_TAGFILTERSELECTEDLIST';
// 标签字段独立加载状态
export const SET_TAG_INFO_LOADING = 'SET_TAG_INFO_LOADING';
// 家医模块的选中居民
export const SET_FAMILY_DOCTOR_SELECT_LIST = 'SET_FAMILY_DOCTOR_SELECT_LIST';
export const DEL_FAMILY_DOCTOR_SELECT_LIST = 'DEL_FAMILY_DOCTOR_SELECT_LIST';
